/**
 * 구 카드내역 탭 (페이엣) — /adm/cardpay?tab=legacy. Pages/Admin/CardPay 가 만들어 쓴다.
 * 탭을 처음 열 때 DataTable 을 만든다. 이후엔 ajax 만 다시 친다.
 * 회원검색 규약은 결제 탭과 같다('이름#번호' 또는 이름 — MemberQueryService::resolveSearchNums).
 */
export default class CardPayLegacy {
    constructor() {
        this.$table = null;
        this.editNum = 0;
        this.searchTimer = null;
        $('#lm-save').on('click', () => this.saveMemo());
    }

    build() {
        const esc = (s) => $('<div>').text(s == null ? '' : String(s)).html();
        const num = (v) => (parseInt(v, 10) || 0).toLocaleString();

        $j.F.Admin.Util.memberSearch('find-user-kwd-legacy');
        $('#find-user-kwd-legacy').on('input', () => {
            clearTimeout(this.searchTimer);
            this.searchTimer = setTimeout(() => this.$table.ajax.reload(), 450);
        });

        this.$table = new DataTable('#legacyTable', {
            columns: [
                {data: 'approval_time', title: '결제일', render: v => $j.Common.Util.formatDateTime(v)},
                {data: 'pay_bankaccount', title: '계좌'},
                // 회원명은 **소유자** 이름이다(결제는 소속자가 할 수 있다) — 번호도 소유자 것(owner_no)을 써야 같은 사람을 가리킨다
                {data: 'mem_name', title: '회원명', render: (v, t, r) => $j.F.Admin.Member.Pop.cell(r.owner_no, v)},
                {data: 'ordernum', title: '오더번호', render: v => v == 9999999 ? '외부작업' : esc(v)},
                {data: 'workfield', title: '내용', render: v => esc(v)},
                {data: null, title: '승인포인트', className: 'amt', render: (v, t, r) => num((parseInt(r.amount, 10) || 0) + (parseInt(r.tax, 10) || 0))},
                {data: 'cahs_realinput', title: '실지급액', className: 'amt', render: v => num(v)},
                {data: 'card_name', title: '카드사', render: v => esc(v)},
                {data: 'approval_no', title: '승인번호', className: 'mono', render: v => esc(v)},
                {data: 'pmemo', title: '비고', className: 'cp-left memo-cell', render: v => esc(v)},
                {data: 'cancel_time', title: '상태', render: v => v ? '<span class="pill p-cancel">취소</span>' : '<span class="pill p-ok">승인</span>'},
            ],
            createdRow: (row, r) => $(row).attr('data-num', r.num),
            ajax: {
                url: '/adm/ajax/card/payments',
                type: 'post',
                data: (d) => { d.findUserKwd = $('#find-user-kwd-legacy').val(); },
                dataSrc: (res) => {
                    $('#tab-c-legacy').text(Number(res.recordsTotal || 0).toLocaleString());
                    // 검색칸 ✕ — 자동완성으로 채워진 경우도 받을 때 맞춘다(CardPay 의 syncSearchX 와 같다)
                    $('.fsearch-x[data-for="find-user-kwd-legacy"]').prop('hidden', !$('#find-user-kwd-legacy').val());
                    return res.data || [];
                },
            },
            processing: true,
            serverSide: true,
            ordering: false,
            displayLength: 20,
            lengthChange: false,
            searching: false,
        });

        const self = this;
        $('#legacyTable tbody').on('click', 'td.memo-cell', function () {
            const r = self.$table.row($(this).closest('tr')).data();
            if (!r) return;
            self.editNum = r.num;
            $('#lm-title').text(`승인번호 [ ${r.approval_no || ''} ] 메모 입력`);
            $('#lm-input').val(r.pmemo || '');
            $('#legacyMemoModal').addClass('on');
            $('#lm-input').trigger('focus');
        });
    }

    load() {
        if (!this.$table) this.build(); else this.$table.ajax.reload(null, false);
    }

    /** 탭 숫자만 — 표를 만들기 전(다른 탭에 있을 때)에도 탭 머리에 건수가 뜨게 */
    count() {
        if (this.$table) return;
        $.post('/adm/ajax/card/payments', { start: 0, length: 1 }, (res) => {
            if (!this.$table) $('#tab-c-legacy').text(Number(res.recordsTotal || 0).toLocaleString());
        });
    }

    closeMemo() { $('#legacyMemoModal').removeClass('on'); }

    saveMemo() {
        if (!this.editNum) return;
        const memo = $('#lm-input').val().trim();
        $.post('/adm/ajax/card/memo', { jobnum: this.editNum, jobmemo: memo }, (res) => {
            if (!res.success) { $j.Common.Util.swalert('메모 저장에 실패했습니다.'); return; }
            this.closeMemo();
            this.$table.ajax.reload(null, false);
        });
    }
}
